module.exports = __webpack_public_path__ + "static/media/search-icon.602fe930.svg";